import { paginationSize } from '../../../constants/constants';
import { ADD_USER_CASE_TO_MY_LIBRARY_SUCCESS, ALL_CASES_PAGINATION, FETCH_ALL_USER_CASES_ERROR, FETCH_ALL_USER_CASES_START, FETCH_ALL_USER_CASES_SUCCESS, FETCH_USER_CASES_BY_REPORT_ID_ERROR, FETCH_USER_CASES_BY_VISIT_ID_SUCCESS, SET_ALL_CASES_FILTER } from "../../actions/AllCasesAction";
import _ from 'lodash';

const INIT_STATE = {
    allCases: [],
    loading: false,
    message: '',
    error: '',
    allCasesPagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0
    },
    searchFilter: {
        diagnosis: "",
        description: "",
        tags: ""
    },
    userCases: []
}

export const allCasesReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    switch (action.type) {
        case FETCH_ALL_USER_CASES_START:
            return { ...state, error: '', message: '', loading: true }

        case FETCH_ALL_USER_CASES_SUCCESS:
            return { ...state, error: '', message: '', loading: false, allCases: action.allCases.length > 0 ? [...action.allCases] : [] }

        case FETCH_ALL_USER_CASES_ERROR:
            return { ...state, loading: false, error: '', allCases: [] }

        case ALL_CASES_PAGINATION: {
            return { ...state, allCasesPagination: { ...action.pagination } };
        }
        case SET_ALL_CASES_FILTER: {
            return { ...state, searchFilter: action.searchFilter };
        }
        case ADD_USER_CASE_TO_MY_LIBRARY_SUCCESS: {
            let newState = _.cloneDeep(state);
            newState.allCases.push(action.userCase);
            return { ...newState };
        }
        case FETCH_USER_CASES_BY_VISIT_ID_SUCCESS: {
            return { ...state, userCases: _.cloneDeep(action.userCases) }

        }
        case FETCH_USER_CASES_BY_REPORT_ID_ERROR: {
            return { ...state, userCases: [] }

        }
        default:
            return state;
    }
}
export default allCasesReducer;